import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const SectorRepository = RepositoryFactory.get('RailwayRepository')['SectorRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get, create } = DefaultStoreActions(SectorRepository)

export const STORE_MODULE_NAME = 'sector';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {
        isVerticalMenuActive: false,
    },
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
        create: create,
    },
}
